import LTR from "@brand-icons/ploom/package-check/package-check-ltr.svg";
import RTL from "@brand-icons/ploom/package-check/package-check-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageCheckIcon = iconFactory("PackageCheckIcon", LTR, RTL);
